// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {usePlantFromHierarchyId} from '@hproduce/suite-core'
import {ThemeProvider} from '@mui/material'
import {generatePath, RouteObject, useNavigate} from 'react-router'

import {majorOutageLeadDashboardFeatureTranslations} from '../localization'
import {MajorOutageLeadDashboard} from '../pages'
import {getDowntimeDashboardUrl, getRcfaListUrl} from '../utils'

const SuiteMajorOutageLeadDashboard = () => {
  const upmPlant = usePlantFromHierarchyId()
  const navigate = useNavigate()

  if (!upmPlant) {
    return null
  }

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  const rcfaListHref = getRcfaListUrl(upmPlant.upmId)
  const plantDowntimeHref = getDowntimeDashboardUrl(upmPlant.upmId)

  // TODO: renderRunningTimeTooltipFooter, shiftSummaryHref, onEventClick
  return (
    <MajorOutageLeadDashboard
      plantId={upmPlant.plantId}
      plantDowntimeHref={plantDowntimeHref}
      rcfaListHref={rcfaListHref}
      onEquipmentClick={navigateToStoppageAnalysis}
    />
  )
}

const SuiteMajorOutageLeadDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={majorOutageLeadDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <SuiteMajorOutageLeadDashboard />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const majorOutageLeadDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteMajorOutageLeadDashboardRouteWrapper />
    },
    stoppageAnalysisSubRoute
  ]
}
